module.exports = __webpack_public_path__ + "static/media/arrowBack.8043edb6.svg";